const Provider = require("./Provider");
const PropTypes = require("prop-types");
const {observable} = require("mobx");
const debounce = require("helpers/debounce");
const inject = require("../decorators/Injector");
const Errors = require("./Errors");

@inject(["store", "data"])
class Collector extends Provider {

    data = {};

    constructor(props) {
        super(props);

        this.state = {
            ...super.state,
            errors: {}
        };
return;
        if (props.data && props.data) {
            this.data = props.data;
            console.log('data value', this.data);
        }

    }

    componentDidUpdate(prevProps) {
        return;
        if (prevProps.default !== this.props.default) {
            this.data = this.props.default;
            this.updateUuid();
            console.log('data updated in collector from default');
        } else if (prevProps.data !== this.props.data) {
            this.data = this.props.data;
            this.updateUuid();
            console.log('data updated in collector');
        }
    }

    /////////////////////////////////
    // Statics
    /////////////////////////////////

    static get propTypes() {
        return {
            default: PropTypes.object,
            store: PropTypes.object.isRequired,
            debounce: PropTypes.bool
        };
    }

    static get defaultProps() {
        return {
            default: {},
            debounce: false,
            debounceDelay: 200
        };
    }

    /////////////////////////////////
    // Change handlers
    /////////////////////////////////

    onChange() {
        if (this.props.onChange && typeof this.props.onChange === "function") {
            return this.props.onChange(this.data, this);
        }
    }

    get debounceDelay() {
        return this.props.debounceDelay;
    }

    onChangeDebounced = debounce(this.debounceDelay, () => {
        this.onChange();
    });

    _onChange() {
        if (this.props.debounce === true) {
            this.onChangeDebounced();
        } else {
            this.onChange();
        }
    }

    /////////////////////////////////
    // Submit helpers
    /////////////////////////////////

    isNew() {
        return (this.id !== null || this.id > 0) === false;
    }

    get id() {
        if (this.props.store.active === null) {
            return null;
        }
        return this.props.store.active.id;
    }

    submit(data = null, alert = true, refresh = false) {

        if (data === null) {
            data = this.data;
        }

        let options = {};

        const action = this.isNew() ?
            () => this.props.store.create(data, options, alert) :
            () => this.props.store.update(this.id, data, options, alert);

        let promise = action();

        return promise.then((response) => {

            if (refresh === true) {

                if (response && response.data) {

                    let errors = {};

                    if (response.data.payload) {
                        this.props.store._updateActive(response.data.payload.id).then(() => {
                            this.setState({errors: errors});
                        });
                    }

                    if (response.data.errors) {
                        this.setState({errors: response.data.errors});
                    }

                }
            }

            return response;
        }).catch((error, response) => {
            this.setState({errors: this.props.store.response.errors});
            throw error;
        });
    }

    /////////////////////////////////
    // Data helpers
    /////////////////////////////////

    splitName(name) {
        if (typeof(name) !== 'string') {
            return [];
        }
        return name.split(/[\[\]\.]/).filter(part => part !== "");
    }


    setValue(name, value) {

        let nameFrags = this.splitName(name);

        let data = this.data;

        if (data === null) {
            data = {};
        }

        let ref = data;

        let fragment = null;

        if (nameFrags.length > 0) {
            while (nameFrags.length > 1) {
                fragment = nameFrags.shift();
                if (typeof(ref[fragment]) === 'undefined' || ref[fragment] === null) {
                    ref[fragment] = {};
                }
                ref = ref[fragment];
            }
        }

        fragment = nameFrags.shift();

        ref[fragment] = value;

        this.data = data;
    }

    autocollectedFields = {};

    setAutocollect(name, field) {
        this.autocollectedFields[name] = field;
    }

    autoCollect() {
        let keys = Object.keys(this.autocollectedFields);
        keys.forEach((name, index) => {
            let field = this.autocollectedFields[name];
            this.setValue(name, field.state.current_value);
        });
    }

    updateValue(name, value) {
        this.setValue(name, value);
        this.autoCollect();
        this._onChange();
    }

    /////////////////////////////////
    // Helpers
    /////////////////////////////////

    resolve() {
        return this;
    }

    get providerProps() {
        return {
            collector: this.resolve()
        };
    }

    render() {
        return (
            <Errors errors={this.state.errors} >
                {super.render()}
            </Errors >
        );
    }

}

module.exports = Collector;